module.exports = __webpack_public_path__ + "static/media/nHJbYr9zUl.c9e952cd.jpg";